/**
 * 비로그인 오픈클래스·장바구니 탐색 경로
 * — apiClient 401 시 전역 로그인 리다이렉트 완화, queryClient와 동일 판별
 */
export function isPublicShoppingBrowsePath(pathname: string): boolean {
	if (
		pathname === '/open-class-list' ||
		pathname === '/cart' ||
		pathname === '/order-confirm' ||
		pathname === '/pay/toss/success' ||
		pathname === '/pay/toss/fail'
	) {
		return true;
	}
	return /^\/open-class\/[^/]+$/.test(pathname);
}
